export default __webpack_public_path__ + "static/media/Schwarz.1f7523e0.jpg";